import { useState, useEffect, useCallback } from "react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const DO_PHOTOS = "https://c3store.nyc3.digitaloceanspaces.com/mwff/Photos";

interface GalleryItem {
  id: number;
  label: string;
  subLabel?: string;
  src: string;
}

const GALLERY_ITEMS: GalleryItem[] = [
  // ── 2024 ──────────────────────────────────────────────────────────────────
  {
    id: 1,
    label: "Poster Signing",
    subLabel: "Fear Fest 2024",
    src: `${DO_PHOTOS}/2024-10-02_18-23-43_000.jpg`,
  },
  {
    id: 2,
    label: "Filmmaker Signs Poster",
    subLabel: "Fear Fest 2024",
    src: `${DO_PHOTOS}/2024-10-02_18-24-23_000.jpg`,
  },
  {
    id: 3,
    label: "Poster Signing",
    subLabel: "Fear Fest 2024",
    src: `${DO_PHOTOS}/2024-10-02_18-25-23_000.jpg`,
  },
  {
    id: 4,
    label: "Packed House",
    subLabel: "Kan-Kan Cinema 2024",
    src: `${DO_PHOTOS}/2024-10-02_18-26-40_000.jpg`,
  },
  {
    id: 5,
    label: "Filmmaker Q&A",
    subLabel: "Fear Fest 2024",
    src: `${DO_PHOTOS}/2024-10-02_18-35-06_000.jpg`,
  },
  {
    id: 6,
    label: "Post-Screening Q&A",
    subLabel: "Fear Fest 2024",
    src: `${DO_PHOTOS}/2024-10-02_18-36-01_000.jpg`,
  },
  {
    id: 7,
    label: "Award Presentation",
    subLabel: "Fear Fest 2024",
    src: `${DO_PHOTOS}/2024-10-02_20-49-04_000.jpg`,
  },
  {
    id: 8,
    label: "Best of Fest Winner",
    subLabel: "MWFF 2024",
    src: `${DO_PHOTOS}/2024-10-09_15-09-06_771.jpeg`,
  },
  {
    id: 9,
    label: "Award Winners",
    subLabel: "Fear Fest 2024",
    src: `${DO_PHOTOS}/2025-11-26_09-57-52_000.jpeg`,
  },
  // ── 2025 ──────────────────────────────────────────────────────────────────
  {
    id: 10,
    label: "Filmmaker Mixer",
    subLabel: "Fear Fest 2025",
    src: `${DO_PHOTOS}/2025-09-27_15-42-08_000.jpeg`,
  },
  {
    id: 11,
    label: "Welcome Reception",
    subLabel: "Fear Fest 2025",
    src: `${DO_PHOTOS}/2025-09-27_15-42-12_000.jpeg`,
  },
  {
    id: 12,
    label: "Filmmaker Mixer",
    subLabel: "Kan-Kan Brasserie",
    src: `${DO_PHOTOS}/2025-09-27_15-42-28_000.jpeg`,
  },
  {
    id: 13,
    label: "Networking",
    subLabel: "Fear Fest 2025",
    src: `${DO_PHOTOS}/2025-09-27_15-42-39_000.jpeg`,
  },
  {
    id: 14,
    label: "Filmmaker Mixer",
    subLabel: "Fear Fest 2025",
    src: `${DO_PHOTOS}/2025-09-27_15-43-06_000.jpeg`,
  },
  {
    id: 15,
    label: "Welcome Filmmakers",
    subLabel: "2025 Selections",
    src: `${DO_PHOTOS}/2025-09-27_15-47-51_000.jpeg`,
  },
  {
    id: 16,
    label: "MWFF Merch",
    subLabel: "Fear Fest 2025",
    src: `${DO_PHOTOS}/2025-09-27_16-12-35_417.jpg`,
  },
  {
    id: 17,
    label: "Award Winners",
    subLabel: "Fear Fest 2025",
    src: `${DO_PHOTOS}/2025-09-27_16-34-38_632.jpg`,
  },
  {
    id: 18,
    label: "Opening Remarks",
    subLabel: "Kan-Kan Cinema",
    src: `${DO_PHOTOS}/2025-09-27_17-00-00_000.jpeg`,
  },
  {
    id: 19,
    label: "Merch & Info Table",
    subLabel: "MWFF Team",
    src: `${DO_PHOTOS}/2025-09-27_17-49-18_474.jpg`,
  },
  {
    id: 20,
    label: "Awards Stage",
    subLabel: "Fear Fest 2025",
    src: `${DO_PHOTOS}/2025-09-27_18-03-04_423.jpg`,
  },
  {
    id: 21,
    label: "Awards Ceremony",
    subLabel: "Fear Fest 2025",
    src: `${DO_PHOTOS}/2025-09-27_19-16-34_000.jpeg`,
  },
  {
    id: 22,
    label: "Presenting Awards",
    subLabel: "Fear Fest 2025",
    src: `${DO_PHOTOS}/2025-09-27_19-17-01_000.jpeg`,
  },
  {
    id: 23,
    label: "Full House",
    subLabel: "Kan-Kan Cinema 2025",
    src: `${DO_PHOTOS}/2025-09-27_20-17-26_896.jpg`,
  },
  {
    id: 24,
    label: "Thank You Sponsors",
    subLabel: "Fear Fest 2025",
    src: `${DO_PHOTOS}/2025-09-27_20-22-05_534.jpg`,
  },
  {
    id: 25,
    label: "MWFF Team",
    subLabel: "Fear Fest 2025",
    src: `${DO_PHOTOS}/2025-09-27_20-29-24_130.jpg`,
  },
  {
    id: 26,
    label: "Best of Fest Trophy",
    subLabel: "Fear Fest 2025",
    src: `${DO_PHOTOS}/2025-09-28_08-12-05_261.jpg`,
  },
];

const PAGE_SIZE = 10;

export default function Gallery() {
  const ref = useScrollAnimation();
  const [selectedIdx, setSelectedIdx] = useState<number | null>(null);
  const [page, setPage] = useState(0);

  const selected = selectedIdx !== null ? GALLERY_ITEMS[selectedIdx] : null;
  const totalPages = Math.ceil(GALLERY_ITEMS.length / PAGE_SIZE);
  const paginated = GALLERY_ITEMS.slice(
    page * PAGE_SIZE,
    (page + 1) * PAGE_SIZE,
  );

  const closeModal = useCallback(() => setSelectedIdx(null), []);
  const goPrev = useCallback(
    () => setSelectedIdx((i) => (i !== null && i > 0 ? i - 1 : i)),
    [],
  );
  const goNext = useCallback(
    () =>
      setSelectedIdx((i) =>
        i !== null && i < GALLERY_ITEMS.length - 1 ? i + 1 : i,
      ),
    [],
  );

  useEffect(() => {
    if (selectedIdx === null) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") closeModal();
      if (e.key === "ArrowLeft") goPrev();
      if (e.key === "ArrowRight") goNext();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [selectedIdx, closeModal, goPrev, goNext]);

  useEffect(() => {
    document.body.style.overflow = selectedIdx !== null ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedIdx]);

  return (
    <section
      id="gallery"
      style={{
        background: "#0f0f14",
        padding: "clamp(64px,10vw,120px) clamp(20px,5vw,80px)",
      }}
    >
      <div ref={ref} style={{ maxWidth: "1280px", margin: "0 auto" }}>
        {/* Header */}
        <div style={{ marginBottom: "48px" }}>
          <div
            className="section-label animate-on-scroll"
            style={{ marginBottom: "16px" }}
          >
            Through the Lens of Terror
          </div>
          <h2
            className="display-heading animate-on-scroll"
            style={{
              fontSize: "clamp(2.5rem,6vw,4.5rem)",
              color: "#e8e8e8",
              transitionDelay: "100ms",
            }}
          >
            Event <span style={{ color: "#cc0000" }}>Gallery</span>
          </h2>
        </div>

        {/* Masonry Grid */}
        <div
          className="gallery-grid animate-on-scroll"
          style={{ transitionDelay: "200ms" }}
        >
          {paginated.map((item) => (
            <div
              key={item.id}
              className="gallery-item"
              style={{ cursor: "pointer" }}
              onClick={() => setSelectedIdx(GALLERY_ITEMS.indexOf(item))}
            >
              <div
                className="gallery-placeholder"
                style={{ background: "#0a0a0f" }}
              >
                <img
                  src={item.src}
                  alt={item.label}
                  loading="lazy"
                  style={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                />
              </div>

              <div className="gallery-overlay">
                <span>View</span>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            marginTop: "40px",
          }}
        >
          <button
            onClick={() => setPage((p) => p - 1)}
            disabled={page === 0}
            style={{
              padding: "8px 22px",
              borderRadius: "999px",
              border: `1px solid ${page === 0 ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.12)"}`,
              background: "transparent",
              color:
                page === 0 ? "rgba(136,136,153,0.3)" : "rgba(136,136,153,0.8)",
              fontFamily: '"Bebas Neue", cursive',
              fontSize: "0.85rem",
              letterSpacing: "0.15em",
              cursor: page === 0 ? "default" : "pointer",
              transition: "all 0.2s ease",
            }}
          >
            ← Prev
          </button>
          <span
            style={{
              fontFamily: '"Bebas Neue", cursive',
              fontSize: "0.85rem",
              letterSpacing: "0.15em",
              color: "rgba(136,136,153,0.8)",
            }}
          >
            {page + 1} / {totalPages}
          </span>
          <button
            onClick={() => setPage((p) => p + 1)}
            disabled={page === totalPages - 1}
            style={{
              padding: "8px 22px",
              borderRadius: "999px",
              border: `1px solid ${page === totalPages - 1 ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.12)"}`,
              background: "transparent",
              color:
                page === totalPages - 1
                  ? "rgba(136,136,153,0.3)"
                  : "rgba(136,136,153,0.8)",
              fontFamily: '"Bebas Neue", cursive',
              fontSize: "0.85rem",
              letterSpacing: "0.15em",
              cursor: page === totalPages - 1 ? "default" : "pointer",
              transition: "all 0.2s ease",
            }}
          >
            Next →
          </button>
        </div>

        {/* Tagline */}
        <p
          className="animate-on-scroll"
          style={{
            textAlign: "center",
            marginTop: "24px",
            fontSize: "0.85rem",
            color: "rgba(136,136,153,0.7)",
            letterSpacing: "0.1em",
          }}
        >
          Follow us <span style={{ color: "#cc0000" }}>@midwestfearfest</span>{" "}
          for live event photos &amp; behind-the-scenes content.
        </p>
      </div>

      {/* Modal */}
      {selected && selectedIdx !== null && (
        <div
          onClick={closeModal}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1000,
            background: "rgba(0,0,0,0.85)",
            backdropFilter: "blur(6px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
            padding: "24px",
            animation: "fadeIn 0.2s ease",
          }}
        >
          {/* Prev button */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              goPrev();
            }}
            disabled={selectedIdx === 0}
            aria-label="Previous image"
            style={{
              flexShrink: 0,
              width: "44px",
              height: "44px",
              borderRadius: "50%",
              border: "1px solid rgba(255,255,255,0.2)",
              background: "rgba(0,0,0,0.6)",
              color: selectedIdx === 0 ? "rgba(255,255,255,0.2)" : "#e8e8e8",
              fontSize: "1.2rem",
              cursor: selectedIdx === 0 ? "default" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
            }}
          >
            ‹
          </button>

          {/* Image card */}
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              maxHeight: "90vh",
              maxWidth: "min(860px, 80vw)",
              borderRadius: "14px",
              overflow: "hidden",
              boxShadow:
                "0 32px 80px rgba(0,0,0,0.7), 0 0 0 1px rgba(204,0,0,0.2)",
              animation: "scaleIn 0.22s ease",
            }}
          >
            <img
              key={selected.src}
              src={selected.src}
              alt={selected.label}
              style={{
                display: "block",
                width: "100%",
                height: "auto",
                maxHeight: "90vh",
                objectFit: "contain",
              }}
            />
            {/* Counter + label */}
            <div
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                padding: "32px 16px 14px",
                background:
                  "linear-gradient(to top, rgba(0,0,0,0.85) 0%, transparent 100%)",
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "space-between",
              }}
            >
              <div>
                <div
                  style={{
                    fontFamily: '"Bebas Neue", cursive',
                    fontSize: "1rem",
                    letterSpacing: "0.1em",
                    color: "#e8e8e8",
                  }}
                >
                  {selected.label}
                </div>
                {selected.subLabel && (
                  <div
                    style={{
                      fontSize: "0.7rem",
                      letterSpacing: "0.1em",
                      color: "rgba(136,136,153,0.8)",
                      marginTop: "2px",
                    }}
                  >
                    {selected.subLabel}
                  </div>
                )}
              </div>
              <div
                style={{
                  fontFamily: '"Bebas Neue", cursive',
                  fontSize: "0.8rem",
                  letterSpacing: "0.12em",
                  color: "rgba(136,136,153,0.7)",
                }}
              >
                {selectedIdx + 1} / {GALLERY_ITEMS.length}
              </div>
            </div>
            {/* Close button */}
            <button
              onClick={closeModal}
              aria-label="Close"
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                border: "1px solid rgba(255,255,255,0.2)",
                background: "rgba(0,0,0,0.6)",
                color: "#e8e8e8",
                fontSize: "1rem",
                lineHeight: 1,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              ×
            </button>
          </div>

          {/* Next button */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              goNext();
            }}
            disabled={selectedIdx === GALLERY_ITEMS.length - 1}
            aria-label="Next image"
            style={{
              flexShrink: 0,
              width: "44px",
              height: "44px",
              borderRadius: "50%",
              border: "1px solid rgba(255,255,255,0.2)",
              background: "rgba(0,0,0,0.6)",
              color:
                selectedIdx === GALLERY_ITEMS.length - 1
                  ? "rgba(255,255,255,0.2)"
                  : "#e8e8e8",
              fontSize: "1.2rem",
              cursor:
                selectedIdx === GALLERY_ITEMS.length - 1
                  ? "default"
                  : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
            }}
          >
            ›
          </button>
        </div>
      )}

      <style>{`
        @keyframes fadeIn  { from { opacity: 0; } to { opacity: 1; } }
        @keyframes scaleIn { from { opacity: 0; transform: scale(0.93); } to { opacity: 1; transform: scale(1); } }
      `}</style>
    </section>
  );
}
